// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1l7b{border-radius:3px}\n._y44vrp0f{animation:var(--_bp628)}._16qsat0y{box-shadow:var(--_1o6m8uc)}\n._1e0c1nu9{display:inline}", ""]);
// Exports
module.exports = exports;
